export default {
  opcoesNovas: [],
  opcaoCriada: {},
};